'use strict';
var at = require('./_string-at')(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_advance-string-index.js
// module id = 285
// module chunks = 136